import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

interface PwaUpdateModalProps {
  open: boolean;
  onClose: () => void;
}

const PwaUpdateModal: React.FC<PwaUpdateModalProps> = ({ open, onClose }) => {
  const handleUpdate = (): void => {
    window.location.reload();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Atualização da plataforma</DialogTitle>
      <DialogContent>
        <Typography>
          Olá! Temos uma nova versão da plataforma disponível!<br /><br />
          Por favor clique no botão abaixo para atualizar.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          autoFocus
        >
          Atualizar agora!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PwaUpdateModal; 